"use client";

import { useGamePageData } from "@casino/ui/Games/hooks";
import {
  GameControlsInfo,
  Popover,
  PopoverContent,
  PopoverTrigger,
  TypographyH4,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import GameStatsTable from "./GameStatsTable";
import LiveRtpStrip from "./LiveRtpStrip";

type Props = { game: SingleGameFragment; isLiveRtpEnabled?: boolean };

const GameStatsPopover: FC<Props> = ({ game, isLiveRtpEnabled }) => {
  const { t } = useGamePageData();

  return (
    <Popover>
      <PopoverTrigger asChild>
        <GameControlsInfo
          data-testid="info-button"
          aria-label={t("game.stats.infolabel", "Game stats")}
        />
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="end"
        className="bg-secondary min-w-[371px] max-h-[446px]"
      >
        <TypographyH4>{t("game.stats.title", "Game Stats")}</TypographyH4>
        <LiveRtpStrip game={game} isLiveRtpEnabled={isLiveRtpEnabled} />
        <GameStatsTable game={game} />
      </PopoverContent>
    </Popover>
  );
};

export default GameStatsPopover;
